import { toast } from 'react-toastify';
import {
  RATE_LIMIT_TOAST_COOLDOWN_MS,
  RATE_LIMIT_TOAST_ID,
} from '@/consts/rate-limit';
import { getRateLimitErrorMessage } from '@/utils/rateLimit/getRateLimitErrorMessage';

let lastShownAt = 0;

function isWithinCooldown(now: number): boolean {
  return lastShownAt > 0 && now - lastShownAt < RATE_LIMIT_TOAST_COOLDOWN_MS;
}

export function showRateLimitErrorToast(errorBody: unknown): void {
  const now = Date.now();

  if (isWithinCooldown(now) || toast.isActive(RATE_LIMIT_TOAST_ID)) {
    return;
  }

  lastShownAt = now;

  toast.error(getRateLimitErrorMessage(errorBody), {
    toastId: RATE_LIMIT_TOAST_ID,
  });
}
